import React, { useEffect, useState } from 'react';
import endpoints from '@config/endpoints';
import Auth from '@utils/auth';
import axios from '@utils/axiosExt';
import DownloadIcon from "../../assets/svg/download-01.svg"
import { errorLogger } from '@utils/applicationLogUtils';

const References = () => {
  const [pdfList, setPdfList] = useState<string[] | []>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);


  useEffect(()=>{
    const getAllPdfNames = async () =>{
      try {
        setIsLoading(true)
        const response:any = await axios.get(`${endpoints.getAllPdf}`, Auth.loggedIn());
        setPdfList(response?.data?.data);
      } catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
      }finally{
        setIsLoading(false)
      }
    }

    getAllPdfNames();
  },[])

  const handleDownloadClick = async (pdfname: string) => {
    try {
      const response = await axios.post(
        `${endpoints.downloadReferencePdf}`,
        { pdfname },
        {
          ...Auth.loggedInWithJSON(),
          responseType: 'blob',
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', pdfname + '.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }  catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
    }
  };

  const ugFiles = pdfList.filter(pdf => !pdf.includes('_QRG_'));
  const qrgFiles = pdfList.filter(pdf => pdf.includes('_QRG_'));

  const referenceModules = [
    {
      moduleCode:'ug',
      headerText : 'Download User Guides',
      list : ugFiles,
    },
    {
      moduleCode:'qrg',
      headerText : 'Download QRG Files',
      list : qrgFiles,
    },
  ]

  return (
    <div>
      {
        referenceModules.map((item, index) =>(
        <div key={index} className='references-container'>
          <div className={`refrences-wrapper ${item.moduleCode}-wrapper`}>
          <h4 className='references-sub-header'>{item.headerText}</h4>
          {
            isLoading ? <div className='loader'></div> : 
             <div className='references-list-container'>
            {item?.list?.map((pdfname, index) => (
              <div key={index} className='references-item' title={'Click to download'}>
                <div className='references-file-name'>{pdfname}</div>
                <span onClick={() => handleDownloadClick(pdfname)} title='Download PDF'>{<DownloadIcon/>}</span>
              </div>
            ))}
            </div>
          }
          </div>
        </div>
        ))
      }
    </div>
  );
};

export default References;